import client from "./axiosConfig";

export const getNotifications = () => {
    const config = {
        url: "/notification/",
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const markAllAsRead = () => {
    const config = {
        url: "notification/mark-all-read/",
        method: "PATCH",
    };
    const response = client(config)
    return response;
}   